<template lang="pug">
  .main
    #sidebar
      MapInfo(:projectInfo="projectInfo" :color="color" :descriptionIndex="descriptionIndex" @close="showGeneralView()" v-show="showProjectDetail")
      RefugioMapInfo(@close="closeRefugioDetailPanel()" v-show="showRefugioDetail")

    .mapa
      l-map(ref='map' style='min-height: 100vmin; min-height: 100vh;' :zoom='zoom' :center='center' :bounds="globalBounds" :options="{zoomControl: false}")
        l-control-layers(position="bottomright")
        l-control-zoom(position="bottomright")
        l-tile-layer(
          v-for="({ url, attribution, visible, name }) in layers"
          :url="url"
          :name="name"
          :attribution="attribution"
          :visible="visible"
          :key="`tile-layer-${name}`"
          layer-type="base"
        )
        SummaryRefugioPanel
        ControlPanel(v-show="!hidePanelAndFooter")
        Cotas
        CoberturasCentrosMunicipales
        CentrosMunicipales(@show-detail="setCentroMunicipalAndUpdateRoute($event)")
        Instituciones(@show-detail="setInstitucionAndUpdateRoute($event)")
        Refugios(@show-detail="setCurrentRefugioAndUpdateRoute($event)")
        AreasRefugio
        ProjectsArea(
          :showProjectDetailProp="showProjectDetail"
          @showProjectDetail="setShowProjectDetail($event)"
          @allProjectAreasAdded="changeCenterAndZoom()"
        )
        div(@click="hidePanel()" style='height: 100% !important;')
    Footer(v-show="!hidePanelAndFooter")
</template>

<script>
import L from 'leaflet'
import bouncing from 'leaflet.smooth_marker_bouncing'
import { mapActions, mapGetters } from 'vuex'
import mapMixin from '@/mixins/map.js'
import 'leaflet-sidebar/src/L.Control.Sidebar.js'
import 'leaflet-sidebar/src/L.Control.Sidebar.css'
import resize from '@/mixins/resize.js'

export default {
  mixins: [ mapMixin, resize ],
  components: {
    Footer: _ => import('@/components/Footer'),
    Cotas: _ => import('@/components/map/Cotas'),
    MapInfo: _ => import('@/components/map/solucion-definitiva/panel/MapInfo'),
    ProjectsArea: _ => import('@/components/map/solucion-definitiva/mapa/ProjectsArea'),
    RefugioMapInfo: _ => import('@/components/map/solucion-a-corto-plazo/panel/RefugioMapInfo'),
    SummaryRefugioPanel: _ => import('@/components/map/solucion-a-corto-plazo/SummaryRefugioPanel'),
    CentrosMunicipales: _ => import('@/components/map/solucion-a-corto-plazo/mapa/CentrosMunicipalesMapa'),
    CoberturasCentrosMunicipales: _ => import('@/components/map/solucion-a-corto-plazo/mapa/CoberturasCentrosMunicipales'),
    Instituciones: _ => import('@/components/map/solucion-a-corto-plazo/mapa/InstitucionesMapa'),
    Refugios: _ => import('@/components/map/solucion-a-corto-plazo/mapa/RefugiosMapa'),
    AreasRefugio: _ => import('@/components/map/solucion-a-corto-plazo/mapa/AreasRefugio')
  },
  props: {
    msg: String
  },
  computed: {
    ...mapGetters(['isGestionInundacionesView']),
    ...mapGetters({
      projectInfo: 'getProjectInfoInFilterList'
    }),
    color () {
      return this.projectInfo && this.projectInfo.color
    }
  },
  watch: {
    projectInfo (val) {
      if (!val) this.showProjectDetail = false
    },
    showProjectDetail (newVal) {
      if (!this.showRefugioDetail) {
        this.setDetailPaneState(newVal)
      }
    },
    '$route' (newRoute, oldRoute) {
      this.reflectNewRoute(newRoute, oldRoute)
    }
  },
  mounted () {
    if (!this.isMobile) {
      this.hidePanelAndFooter = !this.hidePanelAndFooter
    }

    if (!bouncing) {
      console.warn('Not bouncing library detected')
    }

    this.isMounted = true
    this.showControl('filter')
    this.showControl('projectList')
    this.hideControl('labels')

    this.sidebar = L.control.sidebar('sidebar', {
      position: 'right',
      autoPan: false
    })
    this.map.addControl(this.sidebar)

    this.init()
  },
  data () {
    return {
      initialized: false,
      type: 'projects',
      sidebar: null,
      sidebarIsOpen: false,
      showProjectDetail: false,
      showRefugioDetail: false,
      descriptionIndex: 0,
      hidePanelAndFooter: true
    }
  },
  methods: {

    ...mapActions([
      'showControl',
      'hideControl',
      'activateControl',
      'desactivateControl',
      'hoverProject',
      'unHoverProject',
      'showProjectInfo',
      'setCurrentRefugioByNro',
      'setCentroMunicipalById',
      'setInstitucionById',
      'setCentroMunicipalAndUpdateRoute',
      'setCurrentRefugioAndUpdateRoute',
      'setInstitucionAndUpdateRoute'
    ]),

    init () {
      this.activateControl('shapes')
      if (this.initialized) return
      this.initialized = true

      if (this.isGestionInundacionesView) {
        this.prepareForRefugios()
        this.activateControl('refugios')
        this.reflectNewRoute(this.$route)
        if (!this.shouldShowRefugioPanel()) return
        this.showRefugioDetail = true
        this.showProjectDetail = false
        this.setDetailPaneState(true)
      } else {
        this.prepareForProjects()
        this.activateControl('projectList')
      }
    },

    prepareForRefugios () {
      this.type = 'refugios'
    },

    hidePanel () {
      if (this.isMobile) {
        this.hidePanelAndFooter = !this.hidePanelAndFooter
      }
    },

    prepareForProjects () {
      this.type = 'projects'
      this.activateControl('projects')
      this.desactivateControl('refugios')
    },

    showGeneralView () {
      if (this.isGestionInundacionesView) {
        this.$router.replace('/map?ver=refugios')
        if (!this.isMobile) {
          this.changeCenterAndZoom()
        }
      } else {
        this.$router.replace('/map')
        if (!this.isMobile) {
          this.changeCenterAndZoom()
        }
      }
      this.showProjectDetail = false
    },

    closeRefugioDetailPanel () {
      this.setInstitucionAndUpdateRoute({ })
      this.setCurrentRefugioAndUpdateRoute({ })
      this.setCentroMunicipalAndUpdateRoute({ })
      this.setDetailPaneState(false)
      this.showGeneralView()
    },

    setShowProjectDetail (val) {
      this.showProjectDetail = val
    },

    setDetailPaneState (open) {
      if (open) {
        this.sidebar.show()
        this.sidebarIsOpen = true
      } else {
        this.sidebar.hide()
        this.sidebarIsOpen = false
      }
    },

    reflectNewRoute (newRoute, oldRoute) {
      const showRefugioDetailPanel = () => {
        this.showRefugioDetail = true
        this.showProjectDetail = false
        this.setDetailPaneState(true)
      }

      const handleRefugioRoute = () => {
        const nro = newRoute.query.refugio_nro
        if (nro) {
          showRefugioDetailPanel()
          this.setCurrentRefugioByNro(nro)
          return
        }
        const centroMunicipalId = newRoute.query.centro_municipal_id
        if (centroMunicipalId) {
          showRefugioDetailPanel()
          this.setCentroMunicipalById(centroMunicipalId)
          return
        }
        const institucionId = newRoute.query.institucion_id
        if (institucionId) {
          showRefugioDetailPanel()
          this.setInstitucionById(institucionId)
          return
        }
        if (!this.shouldShowRefugioPanel()) return
        this.showGeneralView()
        this.showRefugioDetail = false
        this.setDetailPaneState(false)
        this.prepareForRefugios()
      }

      switch (newRoute.query.ver) {
        case 'refugios':
          handleRefugioRoute()
          break
        default:
          this.prepareForProjects()
      }
    },

    changeCenterAndZoom (center, zoom) {
      if (this.$route.query.code || this.$route.query.refugio_nro || this.$route.query.centro_municipal_id || this.$route.query.institucion_id) return
      this.globalBounds = this.getAllBounds()
    },

    shouldShowRefugioPanel () {
      return !this.$route.query.code
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~@/styles/map/map-scoped'
@import '~@/styles/map/refugios-scoped'

</style>
<style lang="stylus">
@import '~@/styles/map/map'
@import '~@/styles/map/refugios'

</style>
